import React, { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import {
    ContractCreateEditState,
    ContractCreateEditReducer
} from './contract-create-edit-reducer';
import { IContractAddEditRequest } from '../../../../model/scp/contract/request/contract-add-edit-request';

const ContractCreateEditContext = createContext<ContractCreateEditState | undefined>(undefined);
const ContractCreateEditDispatchContext = createContext({} as any);

export const ContractCreateEditProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { contractId } = useParams();

    const initialState: ContractCreateEditState = {
        contractId,
        contractRequest: {
            yearContract: moment().year()
        } as IContractAddEditRequest,
        typeContract: [],
        categoryProcess: [],
        typeDocument: [],
        unidEntity: [],
        purchases: [],
        files: [],
        file: undefined,
        tabIndex: 0,
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(ContractCreateEditReducer, initialState);

    return (
        <ContractCreateEditContext.Provider value={state}>
            <ContractCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </ContractCreateEditDispatchContext.Provider>
        </ContractCreateEditContext.Provider>
    );
};

export const useContractCreateEditState = () => {
    const context = useContext(ContractCreateEditContext);
    if (context === undefined) {
        throw new Error('useContractCreateEditState must be used within a ContractCreateEditProvider');
    }
    return context;
};

export const useContractCreateEditDispatch = () => {
    const context = useContext(ContractCreateEditDispatchContext);
    if (context === undefined) {
        throw new Error('useContractCreateEditDispatch must be used within a ContractCreateEditProvider');
    }
    return context;
};
